import { Language } from "@/components/Inputs/LanguagePicker/Language.ts";
import { useIsCroatian } from "@/helpers/translation/useIsCroatian.ts";
import { RateGroup, RateGroupTranslation } from "@/helpers/types/types.ts";
import { getLocale } from "@/stores/ApolloClient/helpers/getLocale.ts";
import { useTranslation } from "react-i18next";

export interface GetRGTranslatedInfoResponse extends Pick<RateGroupTranslation, "description" | "name"> {
  translation?: RateGroupTranslation;
  getTranslateRGData: (rg: RateGroup) => {
    translation?: RateGroupTranslation;
    name: string;
    description?: string;
  };
}
/**
 * Retrieves translated information for a RateGroup (RG).
 * Default App language is "hr"
 *     - if it's hr return directly the entity values
 *     - if it's not hr, check if there is a translation for the current language and return it,
 *       if not return the entity values
 * @param {RateGroup} rg The RateGroup object to retrieve translated information for.
 * Returns an object containing the translated information
 */
export const useGetRGTranslated = (rg?: RateGroup): GetRGTranslatedInfoResponse => {
  const { i18n } = useTranslation();

  const isCroatian = useIsCroatian();

  const getTranslateRGData = (rg: RateGroup) => {
    const translation = rg?.translations?.find((t) => t.language === getLocale(i18n.language as Language));
    const enFallback = rg?.translations?.find((t) => t.language === "en");
    const name = isCroatian ? rg?.name : translation?.name || enFallback?.name || rg?.name;
    const description = isCroatian
      ? rg?.description
      : translation?.description || enFallback?.description || rg?.description;
    return { translation, name, description };
  };

  if (rg) {
    return { ...getTranslateRGData(rg), getTranslateRGData };
  }

  return {
    getTranslateRGData,
  };
};
